import * as CostModuleApiActions from '../actions/cost-module-api.actions';
import { ServiceInfo } from '../../../cost-module/models/service-info';


export interface State {
  serviceInfo: ServiceInfo[] | null;
}

export const initialState: State = {
  serviceInfo: null,
};

export function reducer(
  state = initialState,
  action: CostModuleApiActions.CostModuleApiActionsUnion
): State {
  switch (action.type) {
    case CostModuleApiActions.getServiceInfoSuccess.type: {
      return {
        ...state,
        serviceInfo: [...action.data]
      };
    }
    default: {
      return state;
    }
  }
}

export const getServiceInfo = (state: State, unitId) => state.serviceInfo?.find(x => x.unitId === unitId);
